/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppChangedRouteImport } from './routes/_app/changed'
import { Route as AppDeskRouteImport } from './routes/_app/desk'
import { Route as AppMedalsRouteImport } from './routes/_app/medals'
import { Route as AppNoMedalsRouteImport } from './routes/_app/no-medals'
import { Route as AppTallyRouteImport } from './routes/_app/tally'
import { Route as AppAwardIndexRouteImport } from './routes/_app/award/index'
import { Route as AppAwardAwardedRouteImport } from './routes/_app/award/awarded'
import { Route as AppAwardChangedRouteImport } from './routes/_app/award/changed'
import { Route as AppAwardNoMedalsRouteImport } from './routes/_app/award/no-medals'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppChangedRoute = AppChangedRouteImport.update({
  id: '/changed',
  path: '/changed',
  getParentRoute: () => AppRoute,
} as any)
const AppDeskRoute = AppDeskRouteImport.update({
  id: '/desk',
  path: '/desk',
  getParentRoute: () => AppRoute,
} as any)
const AppMedalsRoute = AppMedalsRouteImport.update({
  id: '/medals',
  path: '/medals',
  getParentRoute: () => AppRoute,
} as any)
const AppNoMedalsRoute = AppNoMedalsRouteImport.update({
  id: '/no-medals',
  path: '/no-medals',
  getParentRoute: () => AppRoute,
} as any)
const AppTallyRoute = AppTallyRouteImport.update({
  id: '/tally',
  path: '/tally',
  getParentRoute: () => AppRoute,
} as any)
const AppAwardIndexRoute = AppAwardIndexRouteImport.update({
  id: '/award/',
  path: '/award/',
  getParentRoute: () => AppRoute,
} as any)
const AppAwardAwardedRoute = AppAwardAwardedRouteImport.update({
  id: '/award/awarded',
  path: '/award/awarded',
  getParentRoute: () => AppRoute,
} as any)
const AppAwardChangedRoute = AppAwardChangedRouteImport.update({
  id: '/award/changed',
  path: '/award/changed',
  getParentRoute: () => AppRoute,
} as any)
const AppAwardNoMedalsRoute = AppAwardNoMedalsRouteImport.update({
  id: '/award/no-medals',
  path: '/award/no-medals',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/changed': typeof AppChangedRoute
  '/desk': typeof AppDeskRoute
  '/medals': typeof AppMedalsRoute
  '/no-medals': typeof AppNoMedalsRoute
  '/tally': typeof AppTallyRoute
  '/award/awarded': typeof AppAwardAwardedRoute
  '/award/changed': typeof AppAwardChangedRoute
  '/award/no-medals': typeof AppAwardNoMedalsRoute
  '/award/': typeof AppAwardIndexRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/changed': typeof AppChangedRoute
  '/desk': typeof AppDeskRoute
  '/medals': typeof AppMedalsRoute
  '/no-medals': typeof AppNoMedalsRoute
  '/tally': typeof AppTallyRoute
  '/': typeof AppIndexRoute
  '/award/awarded': typeof AppAwardAwardedRoute
  '/award/changed': typeof AppAwardChangedRoute
  '/award/no-medals': typeof AppAwardNoMedalsRoute
  '/award': typeof AppAwardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_app/changed': typeof AppChangedRoute
  '/_app/desk': typeof AppDeskRoute
  '/_app/medals': typeof AppMedalsRoute
  '/_app/no-medals': typeof AppNoMedalsRoute
  '/_app/tally': typeof AppTallyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/award/awarded': typeof AppAwardAwardedRoute
  '/_app/award/changed': typeof AppAwardChangedRoute
  '/_app/award/no-medals': typeof AppAwardNoMedalsRoute
  '/_app/award/': typeof AppAwardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/login'
    | '/changed'
    | '/desk'
    | '/medals'
    | '/no-medals'
    | '/tally'
    | '/award/awarded'
    | '/award/changed'
    | '/award/no-medals'
    | '/award/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/changed'
    | '/desk'
    | '/medals'
    | '/no-medals'
    | '/tally'
    | '/'
    | '/award/awarded'
    | '/award/changed'
    | '/award/no-medals'
    | '/award'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/login'
    | '/_app/changed'
    | '/_app/desk'
    | '/_app/medals'
    | '/_app/no-medals'
    | '/_app/tally'
    | '/_app/'
    | '/_app/award/awarded'
    | '/_app/award/changed'
    | '/_app/award/no-medals'
    | '/_app/award/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changed': {
      id: '/_app/changed'
      path: '/changed'
      fullPath: '/changed'
      preLoaderRoute: typeof AppChangedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/desk': {
      id: '/_app/desk'
      path: '/desk'
      fullPath: '/desk'
      preLoaderRoute: typeof AppDeskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/medals': {
      id: '/_app/medals'
      path: '/medals'
      fullPath: '/medals'
      preLoaderRoute: typeof AppMedalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/no-medals': {
      id: '/_app/no-medals'
      path: '/no-medals'
      fullPath: '/no-medals'
      preLoaderRoute: typeof AppNoMedalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tally': {
      id: '/_app/tally'
      path: '/tally'
      fullPath: '/tally'
      preLoaderRoute: typeof AppTallyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/award/': {
      id: '/_app/award/'
      path: '/award'
      fullPath: '/award/'
      preLoaderRoute: typeof AppAwardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/award/awarded': {
      id: '/_app/award/awarded'
      path: '/award/awarded'
      fullPath: '/award/awarded'
      preLoaderRoute: typeof AppAwardAwardedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/award/changed': {
      id: '/_app/award/changed'
      path: '/award/changed'
      fullPath: '/award/changed'
      preLoaderRoute: typeof AppAwardChangedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/award/no-medals': {
      id: '/_app/award/no-medals'
      path: '/award/no-medals'
      fullPath: '/award/no-medals'
      preLoaderRoute: typeof AppAwardNoMedalsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppChangedRoute: typeof AppChangedRoute
  AppDeskRoute: typeof AppDeskRoute
  AppMedalsRoute: typeof AppMedalsRoute
  AppNoMedalsRoute: typeof AppNoMedalsRoute
  AppTallyRoute: typeof AppTallyRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAwardAwardedRoute: typeof AppAwardAwardedRoute
  AppAwardChangedRoute: typeof AppAwardChangedRoute
  AppAwardNoMedalsRoute: typeof AppAwardNoMedalsRoute
  AppAwardIndexRoute: typeof AppAwardIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChangedRoute: AppChangedRoute,
  AppDeskRoute: AppDeskRoute,
  AppMedalsRoute: AppMedalsRoute,
  AppNoMedalsRoute: AppNoMedalsRoute,
  AppTallyRoute: AppTallyRoute,
  AppIndexRoute: AppIndexRoute,
  AppAwardAwardedRoute: AppAwardAwardedRoute,
  AppAwardChangedRoute: AppAwardChangedRoute,
  AppAwardNoMedalsRoute: AppAwardNoMedalsRoute,
  AppAwardIndexRoute: AppAwardIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
